import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HomeNavigationService {

  private tabSubject = new BehaviorSubject<string>('History');

  tabSelected$ = this.tabSubject.asObservable();

  currentTab = 'History';

  selectTab(tab: string) {
    this.currentTab = tab;
    this.tabSubject.next(tab);
  }
}